export default () => ({
  accountInvoiceQuickViewId: null
})
